import { AppEvents } from "./../../app-events";
import { AppSettings } from "../../app-settings";
import { AppInsights } from "applicationinsights-js";
import { prop } from "../../decorators/property";
import { autoinject, Container } from "aurelia-dependency-injection";
import { AuthService } from "../../authentication/auth-service";
import { AppUser } from "../../authentication/app-user";

@autoinject
export class ApplicationInsights {

    private ignoreEvents = ["RefreshResultsPagerPopup", "WindowResized"];
    private insightsEnabled = false;
    private user: AppUser;

    constructor(private authService: AuthService, private appEvents: Backbone.Events) {
        this.user = authService.AppUser;
        try {
            if (AppSettings.ApplicationInsightsInstrumentationKey === "") {
                return;
            }

            AppInsights.downloadAndSetup({ instrumentationKey: AppSettings.ApplicationInsightsInstrumentationKey });
            this.insightsEnabled = true;
            this.setupEvents();
        } catch (ex) {
            dev.log("No Application Insights - probably offline.", ex);
        }
    }

    public trackException(exception: Error, handledAt?: string, properties?: {[name: string]: string}, measurements?: {[name: string]: number}, severityLevel?: AI.SeverityLevel) {
        if (!this.insightsEnabled) { return; }
        const logOptions = this.userDetails;

        if (!properties) {
            properties = {};
        }

        for (const property of Object.keys(logOptions)) {
            if (this.isLoggableProperty(logOptions, property))  {
                properties[property] = logOptions[property];
            }
        }

        this.setAppVersionInInsights();
        AppInsights.trackException(exception, handledAt, properties, measurements, severityLevel);
    }

    public getOperationContext(): Microsoft.ApplicationInsights.Context.IOperation {
        if (!AppInsights.context) { return null; }
        return AppInsights.context.operation;
    }

    private setupEvents() {
        Backbone.history.on("all", (route, router) => {
            if (this.insightsEnabled) {
                this.trackPageView();
            }
        });

        this.appEvents.on("all", (eventName, eventOptions) => {
            if (this.insightsEnabled) {
                this.trackEvent(eventName, eventOptions);
            }
        });
    }

    private trackEvent(eventName, eventOptions) {
        if (!this.insightsEnabled) { return; }
        if (!eventName.startsWith("AI:")) { return; }

        if (_.contains(this.ignoreEvents, eventName)) { return; }
        const logOptions = this.userDetails;

        for (const property of Object.keys(eventOptions)) {
            if (this.isLoggableProperty(eventOptions, property))  {
                logOptions[property] = eventOptions[property];
            }
        }

        this.setAppVersionInInsights();
        if (this.user.GoldVisionContactId && this.user.GoldVisionContactId !== "00000000-0000-0000-0000-000000000000") {
            AppInsights.setAuthenticatedUserContext(this.user.GoldVisionContactId, this.user.GoldVisionAccountId);
        }

        AppInsights.trackEvent(eventName.replace("AI:", ""), logOptions);
    }

    private setAppVersionInInsights() {
        if (!AppInsights.context) { return null; }
        AppInsights.context.application.ver = AppSettings.AppVersion;
    }

    private trackPageView() {
        if (!this.insightsEnabled) { return; }
        this.setAppVersionInInsights();

        if (this.user.GoldVisionContactId && this.user.GoldVisionContactId !== "00000000-0000-0000-0000-000000000000") {
            AppInsights.setAuthenticatedUserContext(this.user.GoldVisionContactId, this.user.GoldVisionAccountId);
        }

        AppInsights.trackPageView(null, window.location.pathname, this.userDetails);
    }

    private isLoggableProperty(eventOptions, property: any): boolean {
        return  typeof eventOptions[property] !== "function" &&
                property !== "length" &&
                property !== "model" &&
                property !== "models" &&
                property.substring(0, 1) !== "_";
    }

    private get userDetails() {
        return {GoldVisionContactId: this.user.GoldVisionContactId, GoldVisionAccountId: this.user.GoldVisionAccountId};
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/application-insights.ts